import { getRgObjectsOfType as c, RG_TYPE as i, sum as m } from "@project-rouge/rg-core";
const g = (r) => {
  const t = {}, n = c(r, i.Apartment);
  for (const e of n) {
    const o = e.data.category;
    t[o] || (t[o] = 0), t[o]++;
  }
  const a = Object.keys(t), s = Object.values(t).reduce(m, 0);
  return a.map((e) => ({
    name: e,
    count: t[e],
    ratio: t[e] / s
  }));
};
export {
  g as getApartmentCategoryCounts
};
//# sourceMappingURL=index.js.map
